var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Divider, Grid, Header, Loader, Message, Modal, Segment } from "semantic-ui-react";
import { is4xx } from "../CartPage";
import { ORIGIN } from "../Config";
import proteinLogo from '../images/logo_Protein.png';
import rnaLogo from '../images/logo_RNA.png';
import { deleteWithAuthn } from "../RequestHelpers";
import { productNameForKit } from "./KitIndexHeader";
import { formatMonetaryDecimal } from "./rna-fish/EditKitForm";
import KitDisplay from "./rna-fish/KitDisplay";
import { AutomatedProKit, ManualGoldIfKit, ManualProKit, RnaFishKit } from "./rna-fish/KitModel";
import { ErrorElements } from "./rna-fish/NewRnaFishKitPage";
var StarterKitCartCard = /** @class */ (function (_super) {
    __extends(StarterKitCartCard, _super);
    function StarterKitCartCard(props) {
        var _this = _super.call(this, props) || this;
        _this.starterKitProductTag = function (kit) {
            if (!(kit instanceof AutomatedProKit)) {
                return null;
            }
            return React.createElement(Header, { className: 'chromogenic starter-kit-product-tag', size: 'medium' }, "HCR\u2122 Pro RNA-ISH");
        };
        _this.starterKitDetails = function (kits) {
            var details = detailsForStarterKit(kits);
            if (!details) {
                return React.createElement(React.Fragment, null,
                    React.createElement("p", null, "Included with your registration."),
                    React.createElement("p", null,
                        "Price: $",
                        formatMonetaryDecimal(0)));
            }
            return _this.compactStarterKitDetails(details);
        };
        _this.compactStarterKitDetails = function (details) {
            var rows = compactRowsForStarterKit(details);
            return React.createElement(React.Fragment, null,
                React.createElement(Grid, { className: 'tight-rows starter-kit-compact-details' },
                    details.productType !== "automated-pro" &&
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { className: 'starter-kit-compact-sample', width: 16 }, starterKitSampleSummary(details.sampleType))),
                    rows.map(function (row) {
                        var labelClassName = "starter-kit-compact-label " + (row.componentLabel ? 'starter-kit-compact-component-label' : '');
                        if (row.fullWidth) {
                            return React.createElement(Grid.Row, { className: 'starter-kit-compact-row', key: row.label + "-" + row.value },
                                React.createElement(Grid.Column, { className: labelClassName, width: 16 }, row.label));
                        }
                        return React.createElement(Grid.Row, { className: 'starter-kit-compact-row', key: row.label + "-" + row.value },
                            React.createElement(Grid.Column, { className: labelClassName, width: KitDisplay.labelWidth }, row.label),
                            React.createElement(Grid.Column, { className: 'starter-kit-compact-value', width: KitDisplay.valueWidth }, row.value));
                    })),
                React.createElement(Divider, null),
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Kit total"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(0)))));
        };
        _this.deleteButton = function () {
            return React.createElement(Modal, { closeIcon: true, open: _this.state.deleteModalOpen, onClose: _this.onCancel, trigger: React.createElement(Button, { "aria-label": 'Remove kit', basic: true, className: 'starter-kit-remove-button', icon: 'trash', onClick: _this.onDeleteModalOpenClick, title: 'Remove kit' }) },
                React.createElement(Modal.Header, null, "Confirm Action"),
                React.createElement(Modal.Content, null,
                    React.createElement("p", null, "Are you sure you want to delete the starter kit?"),
                    React.createElement(Button, { icon: 'trash', label: 'Remove kit', labelPosition: 'left', negative: true, onClick: _this.deleteStarterKit })));
        };
        _this.onDeleteModalOpenClick = function () {
            _this.setState({ deleteModalOpen: true });
        };
        _this.onCancel = function () {
            _this.setState({ deleteModalOpen: false, error: false });
        };
        _this.deleteStarterKit = function () {
            var _a, _b;
            (_b = (_a = _this.props).setParentLoadingState) === null || _b === void 0 ? void 0 : _b.call(_a, true);
            _this.setState({ deleting: true }, function () {
                deleteWithAuthn('/cart/starter-kit/')
                    .then(function (resp) {
                    if (is4xx(resp.status)) {
                        return resp.json().then(function (json) {
                            return new ErrorElements(json.errors);
                        });
                    }
                    return resp.json();
                })
                    .then(function (json) {
                    var _a, _b, _c, _d;
                    (_b = (_a = _this.props).setParentLoadingState) === null || _b === void 0 ? void 0 : _b.call(_a, false);
                    if (json instanceof ErrorElements) {
                        _this.setState({ deleting: false, error: true });
                    }
                    else {
                        (_d = (_c = _this.props).onCartChange) === null || _d === void 0 ? void 0 : _d.call(_c, json);
                        _this.setState({ deleting: false, deleteModalOpen: false, error: false });
                    }
                })
                    .catch(function (rej) {
                    var _a, _b;
                    console.error("Couldn't delete starter kit: " + rej);
                    (_b = (_a = _this.props).setParentLoadingState) === null || _b === void 0 ? void 0 : _b.call(_a, false);
                    _this.setState({ deleting: false, error: true });
                });
            });
        };
        _this.state = {
            deleteModalOpen: false,
            deleting: false,
            error: false
        };
        return _this;
    }
    StarterKitCartCard.prototype.render = function () {
        var productName = this.props.kit instanceof AutomatedProKit
            ? ""
            : productNameForKit(this.props.kit, false);
        var starterKitItems = this.props.kits || [this.props.kit];
        var starterKitLogo = logoForStarterKit(this.props.kit);
        var titleSeparator = this.props.kit instanceof AutomatedProKit ? "" : ":";
        return React.createElement(Segment, { className: 'starter-kit-cart-card' },
            React.createElement(Dimmer, { active: this.state.deleting, inverted: true },
                React.createElement(Loader, null)),
            React.createElement("div", { className: 'starter-kit-card-header' },
                React.createElement("div", { className: 'starter-kit-card-title' },
                    React.createElement(Grid, { className: 'kit-index-header starter-kit-index-header' },
                        React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                            React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                                React.createElement(Header, { className: 'kit-num' },
                                    React.createElement("span", { className: 'starter-kit-title-prefix' },
                                        "Starter Kit",
                                        titleSeparator),
                                    productName && React.createElement("span", { className: 'starter-kit-title-product' },
                                        " ",
                                        productName))),
                            ORIGIN === "mi" &&
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                    React.createElement("img", { className: 'kit-index-logo', src: starterKitLogo.img, alt: starterKitLogo.alt }))))),
                this.props.deletable &&
                    React.createElement("div", { className: 'starter-kit-card-actions' }, this.deleteButton())),
            this.state.error && React.createElement(Message, { error: true }, "Could not delete starter kit"),
            this.starterKitProductTag(this.props.kit),
            this.starterKitDetails(starterKitItems));
    };
    return StarterKitCartCard;
}(React.PureComponent));
export default StarterKitCartCard;
var StarterKitDisplayModal = /** @class */ (function (_super) {
    __extends(StarterKitDisplayModal, _super);
    function StarterKitDisplayModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StarterKitDisplayModal.prototype.render = function () {
        return React.createElement(Modal, { closeIcon: true, content: React.createElement("div", { style: { 'padding': '2rem' } },
                React.createElement(StarterKitCartCard, { kit: this.props.kit, kits: this.props.kits })), trigger: this.props.trigger, on: 'click', size: 'small' });
    };
    return StarterKitDisplayModal;
}(React.PureComponent));
export { StarterKitDisplayModal };
// A starter kit is made up of several individual kits of the same product (eg. 3 RnaFishKits),
// added as separate items with no shared id linking them -- collapse to one representative kit per product.
export function uniqueStarterKitGroups(items) {
    var starterKitsByType = new Map();
    items.filter(function (item) { return item.kit.starterKit; }).forEach(function (item) {
        var kitType = item.kit.constructor;
        if (!starterKitsByType.has(kitType)) {
            starterKitsByType.set(kitType, []);
        }
        starterKitsByType.get(kitType).push(item.kit);
    });
    return Array.from(starterKitsByType.values()).map(function (kits) {
        return {
            kit: kits[0],
            kits: kits
        };
    });
}
var logoForStarterKit = function (kit) {
    if (kit instanceof ManualGoldIfKit) {
        return { img: proteinLogo, alt: 'Protein logo' };
    }
    return { img: rnaLogo, alt: 'RNA logo' };
};
var detailsForStarterKit = function (kits) {
    return detailsForRnaFishStarterKit(kits)
        || detailsForManualGoldIfStarterKit(kits)
        || detailsForManualProStarterKit(kits)
        || detailsForAutomatedProStarterKit(kits);
};
var detailsForRnaFishStarterKit = function (kits) {
    var rnaFishKits = kits.filter(function (kit) { return kit instanceof RnaFishKit; });
    if (rnaFishKits.length === 0) {
        return undefined;
    }
    var sampleType = rnaFishKits[0].sampleType.label;
    var amplifiersAndLabels = uniqueStrings(rnaFishKits.reduce(function (values, kit) {
        var amplifier = kit.amplifierComponent;
        if (amplifier) {
            values.push(amplifier.hcrAmplifier.id + " (" + amplifier.label.name + ")");
        }
        return values;
    }, []));
    var bufferVolumes = uniqueStrings(rnaFishKits.reduce(function (values, kit) {
        var buffers = kit.buffersComponent;
        if (buffers) {
            values.push(buffers.hybridization.valueWithUnit, buffers.probeWash.valueWithUnit, buffers.ampBuffer.valueWithUnit, buffers.ampWashBuffer.valueWithUnit);
        }
        return values;
    }, []));
    return {
        productType: "rna-fish",
        sampleType: sampleType,
        amplifierDetails: {
            title: "HCR™ Gold Amplifier",
            amplifierLabel: "Amplifiers",
            amplifiers: amplifiersAndLabels,
            rows: []
        },
        bufferVolumes: bufferVolumes
    };
};
var detailsForManualGoldIfStarterKit = function (kits) {
    var manualGoldIfKits = kits.filter(function (kit) { return kit instanceof ManualGoldIfKit; });
    if (manualGoldIfKits.length === 0) {
        return undefined;
    }
    var sampleType = manualGoldIfKits[0].sampleType.label;
    var encoderIsotypes = uniqueStrings(manualGoldIfKits.reduce(function (values, kit) {
        var encoder = kit.encoderComponent;
        if (encoder) {
            values.push(encoder.encodeA.displayName);
        }
        return values;
    }, []));
    var amplifiersAndLabels = uniqueStrings(manualGoldIfKits.reduce(function (values, kit) {
        var amplifier = kit.amplifierComponent;
        if (amplifier) {
            values.push(amplifier.hcrAmplifier.id + " (" + amplifier.label.name + ")");
        }
        return values;
    }, []));
    var bufferVolumes = uniqueStrings(manualGoldIfKits.reduce(function (values, kit) {
        var buffers = kit.buffersComponent;
        if (buffers) {
            values.push(buffers.antibodyBuffer.valueWithUnit, buffers.antibodyWashBuffer.valueWithUnit, buffers.amplificationBuffer.valueWithUnit, buffers.ampWashBuffer.valueWithUnit);
        }
        return values;
    }, []));
    return {
        productType: "manual-gold-if",
        sampleType: sampleType,
        encoderDetails: {
            isotypes: encoderIsotypes
        },
        amplifierDetails: {
            title: "HCR™ Gold Amplifier",
            amplifierLabel: "Amplifiers",
            amplifiers: amplifiersAndLabels,
            rows: []
        },
        bufferVolumes: bufferVolumes
    };
};
var detailsForManualProStarterKit = function (kits) {
    var manualProKits = kits.filter(function (kit) { return kit instanceof ManualProKit; });
    if (manualProKits.length === 0) {
        return undefined;
    }
    var sampleType = manualProKits[0].sampleType.label;
    var detectKit = manualProKits.find(function (kit) { return kit.detect; });
    var detect = detectKit === null || detectKit === void 0 ? void 0 : detectKit.detect;
    var channels = (detect === null || detect === void 0 ? void 0 : detect.channels) || [];
    var amplifiers = uniqueStrings(channels.reduce(function (values, channel) {
        if (channel.hcrAmplifier) {
            values.push(channel.hcrAmplifier.id);
        }
        return values;
    }, []));
    var enzymes = uniqueStrings(channels.reduce(function (values, channel) {
        if (channel.enzyme) {
            values.push(channel.enzyme.label);
        }
        return values;
    }, []));
    var chromogens = uniqueStrings(manualProKits.reduce(function (values, kit) {
        var _a;
        if (((_a = kit.chromogen) === null || _a === void 0 ? void 0 : _a.chromogen) && kit.chromogen.chromogen.id !== 'NONE') {
            values.push(kit.chromogen.chromogen.label);
        }
        return values;
    }, []));
    var manualProRows = [
        { label: "HCR™ HiFi Probe", value: "Sample Readiness Probe", componentLabel: true },
        { label: "HCR™ Pro Amplifier Kit", value: "", componentLabel: true, fullWidth: true },
    ];
    if (amplifiers.length > 0) {
        manualProRows.push({ label: "Amplifier", value: amplifiers.join(' | ') });
    }
    if (enzymes.length > 0) {
        manualProRows.push({ label: "Enzyme", value: enzymes.join(' | ') });
    }
    if (chromogens.length > 0) {
        manualProRows.push({ label: "Chromogen Kit", value: chromogens.join(' | ') });
    }
    var bufferVolumes = uniqueStrings(manualProKits.reduce(function (values, kit) {
        var buffers = kit.buffers;
        if (buffers) {
            values.push(buffers.hybridizationBuffer.valueWithUnit, buffers.probeWashBuffer.valueWithUnit, buffers.ampWashBuffer.valueWithUnit);
        }
        return values;
    }, []));
    return {
        productType: "manual-pro",
        sampleType: sampleType,
        rows: manualProRows,
        bufferVolumes: bufferVolumes
    };
};
var detailsForAutomatedProStarterKit = function (kits) {
    var _a;
    var automatedProKits = kits.filter(function (kit) { return kit instanceof AutomatedProKit; });
    if (automatedProKits.length === 0) {
        return undefined;
    }
    var probeComponents = automatedProKits
        .reduce(function (values, kit) {
        values.push.apply(values, kit.probeSetComponent);
        return values;
    }, []);
    var positiveControlProbe = probeComponents.find(function (probe) {
        return automatedProProbeSetOrganismName(probe.probeSet) !== "Bacillus subtilis";
    }) || probeComponents[0];
    var positiveControlOrganism = positiveControlProbe === undefined
        ? undefined
        : automatedProProbeSetOrganismDisplayName(positiveControlProbe.probeSet);
    var probeTargets = uniqueStrings(probeComponents
        .map(function (probe) { return automatedProProbeSetTargetName(probe.probeSet); })
        .filter(function (target) { return target.length > 0; }));
    var detect = (_a = automatedProKits.find(function (kit) { return kit.detectComponent !== undefined; })) === null || _a === void 0 ? void 0 : _a.detectComponent;
    var detectChannels = (detect === null || detect === void 0 ? void 0 : detect.channels) || [];
    var enzymes = uniqueStrings(detectChannels.reduce(function (values, channel) {
        if (channel.enzyme) {
            values.push(formatAutomatedProDetectionEnzymeLabel(channel.enzyme.label));
        }
        return values;
    }, []));
    var rows = [
        { label: "Platform", value: automatedProPlatformLabel(automatedProKits[0].platform) },
        { label: "Scale", value: "20 slides" }
    ];
    if (positiveControlOrganism) {
        rows.push({ label: "Organism", value: positiveControlOrganism });
    }
    if (probeTargets.length > 0) {
        rows.push({
            label: "HCR™ HiFi Probes",
            value: starterKitTargetSummary(probeTargets),
        });
    }
    if (enzymes.length > 0) {
        rows.push({ label: "HCR™ Pro Detect", value: enzymes.join(' | ') });
    }
    return {
        productType: "automated-pro",
        sampleType: "Tissue Section",
        rows: rows,
        bufferVolumes: []
    };
};
var uniqueStrings = function (values) {
    return values.filter(function (value, index) { return values.indexOf(value) === index; });
};
var automatedProPlatformLabel = function (platform) {
    switch (platform.id) {
        case "ROCHE":
            return "DISCOVERY ULTRA";
        case "LEICA":
            return "BOND RX / RXm";
        case "ONCORE_PRO_X":
            return "ONCORE Pro X";
        case "BOND_III":
            return "Fully ambient-temperature workflow";
        default:
            return platform.alias || platform.label;
    }
};
var automatedProProbeSetTargetName = function (probeSet) {
    if ("customerTargetName" in probeSet) {
        return probeSet.customerTargetName;
    }
    return probeSet.target.name;
};
var automatedProProbeSetOrganismName = function (probeSet) {
    return probeSet.organism.name;
};
var automatedProProbeSetOrganismDisplayName = function (probeSet) {
    var organism = probeSet.organism;
    var scientificName = "scientificName" in organism ? organism.scientificName.trim() : "";
    return "" + organism.name + (scientificName.length > 0 && scientificName !== organism.name ? " (" + scientificName + ")" : "");
};
var starterKitTargetSummary = function (targets) {
    return targets.join(', ');
};
var formatAutomatedProDetectionEnzymeLabel = function (label) {
    switch (label) {
        case "AP":
            return "AP";
        case "HRP":
            return "HRP";
        default:
            return label;
    }
};
var compactRowsForStarterKit = function (details) {
    var rows = [];
    if (details.productType === "rna-fish") {
        rows.push({
            label: "HCR™ HiFi Probe",
            value: "Sample Readiness Probe",
            componentLabel: true
        });
    }
    if (details.encoderDetails) {
        rows.push({
            label: "HCR™ HiFi Encoder",
            value: details.encoderDetails.isotypes.join(', '),
            componentLabel: true
        });
    }
    if (details.rows) {
        details.rows.forEach(function (row) {
            rows.push({
                label: row.label,
                value: row.value,
                componentLabel: row.componentLabel,
                fullWidth: row.fullWidth
            });
        });
    }
    if (details.amplifierDetails) {
        rows.push({
            label: details.amplifierDetails.title,
            value: details.amplifierDetails.amplifiers.map(formatCompactAmplifierLabel).join(', '),
            componentLabel: true
        });
        details.amplifierDetails.rows.forEach(function (row) {
            rows.push({
                label: row.label,
                value: row.value,
                componentLabel: row.componentLabel
            });
        });
    }
    if (details.bufferVolumes.length > 0) {
        rows.push({
            label: "HCR™ Buffers",
            value: "All",
            componentLabel: true
        });
    }
    return rows;
};
var formatCompactAmplifierLabel = function (label) {
    var match = /^([A-Za-z0-9]+) \(([^)]+)\)$/.exec(label);
    return match ? match[1] + "-" + match[2] : label;
};
var starterKitSampleSummary = function (sampleType) {
    switch (sampleType) {
        case "Whole-Mount":
            return "Whole-Mount (10 samples)";
        case "Tissue Section":
            return "Tissue Section (25 slides)";
        case "Cells on a Slide":
            return "Cells on a Slide (25 slides)";
        case "Cells in Suspension":
            return "Cells in Suspension (10 samples)";
        default:
            return sampleType;
    }
};
//# sourceMappingURL=StarterKitCartCard.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/StarterKitCartCard.js
// module id = 330
// module chunks = 0